/**
 * Geolocation Service
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'geolocation';
const log = debug(MODULE_NAME);

//
// Dependencies
import googleMapsApiPromise from '../google-maps-api';
import * as browserFeatures from '../browser-features';

//
// Constants
import { COMPONENT_RESTRICTIONS } from './config';
const STATUS_OK = 'OK';
const GPS_TIMEOUT = 10000;

//
// Private Functions


/**
 * Gets the user's current location
 * @returns {Promise}
 */
export function getCurrentLocation() {
	if (!browserFeatures.geolocation || !navigator.geolocation) {
		return Promise.reject('Geolocation unavailable.');
	}

	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition((position) => {
			resolve({
				lat: position.coords.latitude,
				lng: position.coords.longitude,
			});
		}, reject, { timeout: GPS_TIMEOUT, maximumAge: GPS_TIMEOUT });
	});
}

/**
 * Gets an address at the provided lat/lng location.
 * @param {{lat: Number, lng: Number}} latLng
 * @returns {Promise<google.maps.GeocoderResult>}
 */
export function geocodeLatLng(latLng) {
	return new Promise((resolve, reject) => {
		// Note: anti-pattern (Nested Promises) used here because Google Maps API uses callbacks.
		googleMapsApiPromise.then((google) => {
			const geocoder = new google.maps.Geocoder;

			geocoder.geocode({ location: latLng }, (results, status) => {
				if (status !== STATUS_OK) {
					reject(status);
				}

				resolve(results[0]);
			});
		}, reject);
	});
}

/**
 * Gets a location at the provided address
 * @param {string} address
 * @param {google.maps.GeocoderComponentRestrictions} componentRestrictions
 * @return {Promise<google.maps.GeocoderResult>}
 */
export function geocodeAddress(address, componentRestrictions = COMPONENT_RESTRICTIONS) {
	return new Promise((resolve, reject) => {
		// Note: anti-pattern (Nested Promises) used here because Google Maps API uses callbacks.
		googleMapsApiPromise.then((google) => {
			const geocoder = new google.maps.Geocoder;

			geocoder.geocode({address, componentRestrictions}, (results, status) => {
				if (status !== STATUS_OK) {
					reject(status);
				}

				resolve(results[0]);
			});
		});
	});
}


// WEBPACK FOOTER //
// ./project/client/src/core/services/geolocation/index.js